import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle, Tooltip } from "reactstrap";
import { withNamespaces } from "react-i18next";

//Import Charts
import ReactApexChart from "react-apexcharts";

const defaultColors = [
  "#5664d2",
  "#1cbb8c",
  "#eeb902",
  "#FF7F50",
  "#9932CC",
  "#90A4AE",
];

class DonutChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      options: {
        labels: [],
        plotOptions: {
          pie: {
            donut: {
              size: "75%",
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        
        colors: defaultColors,
      },
      months: [
        {
          name: "june",
          title: "June",
        },
      ],
      categories: [],
      topFiveCats: false,
      isSet: false
    };
  }

  render() {
    const { t, title, tooltipText, cardStyle, cardClassName = "", bodyStyle } = this.props;
    const hasData =
      Array.isArray(this.state.series) &&
      this.state.series.length > 0 &&
      this.state.series.some(v => Number(v) > 0);


    const emptySeries = [1]; 
    const emptyOptions = {
        ...this.state.options,
        labels: ['No Data'], 
        colors: ['#e0e0e0'], 
        plotOptions: {
            pie: {
                donut: {
                    size: '75%',
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: {
            show: false,
        },
    };
    const chartKey = JSON.stringify(this.state.series) + JSON.stringify(this.state.options.labels);
    const legendColors = this.categoryColors(this.state.categories);
    return (
      <Card className={`flex-grow-1 card_box_Shadow ${cardClassName}`} style={cardStyle}>
        <CardBody style={bodyStyle}>
          <div className="mb-4">
            <CardTitle>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div>{t(title)}</div>

                {tooltipText ? <>  <i
                  className="fa fa-info-circle"
                  aria-hidden="true"
                  id="infoIconU"
                />

               <Tooltip
                  placement="top"
                  isOpen={this.state.topFiveCats}
                  target="infoIconU"
                  toggle={() =>
                    this.setState({
                      topFiveCats: !this.state.topFiveCats,
                    })
                  }
                >
                  {t(tooltipText)}
                </Tooltip> 
                </>
                : null}
              </div>
            </CardTitle>
          </div>
              
          <div className="mb-4">
            <div id="donut-chart" className="apex-charts mb-3">
            {
              <ReactApexChart
                  key={chartKey} 
                  options={hasData ? this.state.options : emptyOptions}
                  series={hasData ? this.state.series : emptySeries}
                  type="donut"
                  height="250"
              />
            }
            </div>

            <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center">
              {this.state.categories.map((category, index) => {
                return (
                  <div key={index} className="d-flex gap-2 align-items-center mt-4">
                    <i
                      className="mdi mdi-circle font-size-10 me-1"
                      style={{ color: legendColors[index] || defaultColors[index % defaultColors.length] }}
                    ></i>
                    <p
                      className="mb-0 me-2"
                      style={{
                        margin: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontSize: "14px",
                      }}
                    >
                      {t(category.title)}
                    </p>
                    <h6 className="my-0 text-nowrap">{category.percent} %</h6>
                  </div>
                );
              })}
            </div>
          </div>
        </CardBody>
      </Card> 
    );
  }

  categoryColors = (categories) => {
    const n = categories.length;
    if (!n) {
      return [];
    }
    if (Array.isArray(this.props.colors) && this.props.colors.length) {
      return categories.map((_, i) => {
        const c = this.props.colors[i];
        return c != null ? c : defaultColors[i % defaultColors.length];
      });
    }
    return categories.map((_, i) => defaultColors[i % defaultColors.length]);
  };

  applyCategoriesToChart = (categories) => {
    const series = categories.map(c => Number(c.amount) || 0);

    const labels = categories.map((c) => {
      const title = this.props.t(c.title);
      return title.length > 50 ? `${title.substring(0, 50)}...` : title;
    });
    const chartColors = this.categoryColors(categories);

  this.setState((prevState) => ({
    categories,
    series,
    options: {
      ...prevState.options,
      labels,
      colors: chartColors,
    },
    isSet: true,
    }));
  };

  componentDidMount() {
    if (this.props.categories?.length) {
      this.applyCategoriesToChart(this.props.categories);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.categories !== this.props.categories ||
      prevProps.colors !== this.props.colors ||
      prevProps.t !== this.props.t
    ) {
      this.applyCategoriesToChart(this.props.categories || []);
    }
  }
}

export default withNamespaces()(DonutChart);
